(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('announcement-carousel')) {
    customElements.define('announcement-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
        if (this.slides.length < 2) return;

        this.initialized = true;
        this.currentIndex = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.stop = this.stop.bind(this);
        this.start = this.start.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
        this.handleVisibility = this.handleVisibility.bind(this);

        this.classList.add('is-initialized');
        this.activate(0);
        this.addEventListener('mouseenter', this.stop);
        this.addEventListener('mouseleave', this.start);
        this.addEventListener('focusin', this.stop);
        this.addEventListener('focusout', this.handleFocusOut);
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.start();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.stop();
        this.removeEventListener('mouseenter', this.stop);
        this.removeEventListener('mouseleave', this.start);
        this.removeEventListener('focusin', this.stop);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        this.initialized = false;
      }

      activate(index) {
        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (slide.matches('a')) slide.tabIndex = isActive ? 0 : -1;
        });
        this.currentIndex = index;
      }

      start() {
        if (this.reduceMotion || this.interval || document.hidden) return;
        this.interval = window.setInterval(() => {
          this.activate((this.currentIndex + 1) % this.slides.length);
        }, 4500);
      }

      stop() {
        window.clearInterval(this.interval);
        this.interval = null;
      }

      handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.start();
      }

      handleVisibility() {
        if (document.hidden) {
          this.stop();
        } else {
          this.start();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
function loadShibutaRecommendations(section) {
  if (!section || section.querySelector('.shibuta-recommendation-grid')) return;
  var request = new XMLHttpRequest();
  request.open('GET', section.dataset.url);
  request.onload = function() {
    if (request.status < 200 || request.status >= 300) return;
    var response = new DOMParser().parseFromString(request.responseText, 'text/html');
    var recommendations = response.querySelector('.product-recommendations');
    if (recommendations) section.innerHTML = recommendations.innerHTML;
  };
  request.send();
}
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-recommendations').forEach(loadShibutaRecommendations);
});
document.addEventListener('shopify:section:load', function(event) {
  var section = event.target.querySelector('.product-recommendations');
  loadShibutaRecommendations(section);
});

  } catch(e) { console.error(e); }
})();
})();
